export class Cliente {
    clienteId: number = 0
    nome: string = ''
    email: string = ''
    telefone: string = ''
    cpf: string = ''
    ativo: boolean = true
}